import React, { useEffect, useState } from "react";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import FsLightbox from "fslightbox-react";
import { Banner } from "../../components/Banner/Banner";
import {
  bloginnerban,
  facebook,
  gallery1,
  leftarrow,
  mainimg,
  moreblog1,
  moreblog2,
  moreblog3,
  coloredArrow,
  playicon,
  whatsapp,
  linkedinblog,
  twitterblog,
  copy,
  mainimgmob,
  bannerInner3,
  blog4Banner
} from "../../images";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import { Link, NavLink } from "react-router-dom";
//utils
import { reduceDescSize } from "../../helpers/utils";

import "./BlogInner4.scss";
import Swiper from "swiper";
import "swiper/swiper-bundle.css";
import MetaDecorator from "../../components/MetaDecorator/MetaDecorator";

const BlogInner = () => {
  const { width } = useWindowDimensions();
  const [copied, setCopied] = useState(false);
  const [toggler, setToggler] = useState(false);
  const [vidLink, setVidLink] = useState("");

  const blogDateArr = [
    {
      date: "June 2, 2022",
      category: "Lorem Ipsum",
      company: "Sanathan",
    },
  ];

  const blogDescArr = [
    {
      id: 1,
      heading: "What Are Some Examples Of Technical Textiles?",
      desc1:
        "Technical textiles in India are a vital component of modern life. These materials are employed in a wide range of industries, from medical gadgets to athletic products. This article will provide an overview of technical textiles, their examples and how it is used nowadays.<br/><br/>First, Let’s understand what is Technical Textile? <br/><br/><strong> What Are Technical Textiles?</strong><br/> <br/>Technical textiles, also known as smart textiles are textile components and products with technical traits and characteristics. It is a textile product manufactured for non-aesthetic purposes, where the function is the primary criterion. They are created from natural and man-made fibres such as Nomex, Kevlar, Spandex, and Twaron, which have better functional features such as higher tenacity, excellent insulation, improved thermal resistance, and so on.<br/><br/> Technical textiles are a promising position in the textile industry. It is employed for the proper application of its functional features and the production of diverse applications. <br/><br/><strong>9 Technical Textiles Examples:</strong><br/>  <br/> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>1. Agrotextiles (Agro-Textiles)</strong><br/>Technical textile applications in agriculture cover all tasks related to the cultivation and harvesting of crops and animals. The primary role of most agricultural textiles is to protect food, animals, or land. Crop production, forestry and horticulture, livestock and poultry husbandry, and fishing are all examples of end uses. The fishing industry consumes a lot of textile materials. Fishing practices are becoming increasingly industrialized, with small net and line fishing techniques being phased out.<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong> 2. Geotextiles (Geo-Textiles)</strong><br/> Geotextiles are all woven, nonwoven, and knitted textile materials used primarily by the civil engineering sector to provide support, drainage, and isolation at or below ground level. Geotextiles are used in a variety of applications, including building, bridge, dam, road, railway, and path construction, as well as embankments, cuttings, dykes, and sub- sea coastal engineering projects. These are increasingly being used for waste containment in hazardous waste disposal sites and industrial and municipal effluent treatment facilities.<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong> 3. Hometech (Domestic Textiles)</strong><br/> Hometech is the fourth-largest seller of technical textiles in the world. Hometech products contain both synthetic and natural fibres. Western countries account for the biggest market share of hometech textiles followed by the Asia Pacific region. Hometech textiles are majorly used in furniture &amp; interior decoration, sun protection, cushion materials, carpeting, fireproofing, wall coverings, flooring and textile reinforced fittings etc. The hometech textiles market is supposed to observe a great increase of 4.8% CAGR year on year.<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>4. Indutech (Industrial Textiles)</strong><br/> Indutech refers to textiles used in several industrial applications. There is increasing demand from uses like cleansing, conveyancing industrial instrumentation, agriculture and farming, environmental protection, sport and leisure, unit furnishing and coverings, and packaging. Technical textiles are proving their worth in yet another field, contributing to the advancement of industrial and technological growth. Technical textiles include mechanical and textile engineering goods and solutions. Indutech Textiles Market size is growing at a moderate pace with substantial growth rates over the last few years. It estimated that the market will grow significantly in the period from 2021 to 2028.<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>5. Medtech (Medical Textiles) </strong><br/>The word MedTech refers to technical textiles used in the medical and rehabilitation industries. It entails the development, processing, and application of safe and sanitary products. Medical textiles from the MedTech sector help patients get the best care possible. Because of their high process dependability requirements, MedTech products are among the most advanced technical textiles. Textiles materials that are used in medical applications include fibres, yarns, fabrics and composites. Depending upon the application, the major requirements of medical textiles are absorbency, tenacity, flexibility, softness and at times biostability or biodegradability.<br/><br/> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong> 6. Mobiltech (Textiles Used In Transport)</strong><br/> Mobiltech textiles are utilised in the automotive and transportation industries. It&#39;s some sort of technological fabric. Some of the uses are automobiles, automotive components, aircraft and railways. Mobiltech is concerned with more than just isolation and safety; it is also concerned with comfort and aesthetics. Mobiltech is used in seatbelt webbing, car upholstery, airbags, helmets and tyre cords. Materials like nylon, polyester and polyester blends are used extensively in mobiltech.<br/><br/> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>7. Ecotech (Eco-Friendly Textiles) </strong><br/>Oekotech or Ecotech is a textile application in environmental protection. It includes floor sealants, erosion protection, air cleaning, water pollution prevention, water cleaning, waste treatment/recycling, depositing area construction, product extraction, and household water sewerage plant. The key component in this is landfill waste management and the secondary protection is the chemical/oil industries. <br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>8. Protech (Protective Textiles)</strong><br/>Protective textile is a type of technical cloth that has exceptional protective properties to protect against a wide range of natural and man-made threats. It occasionally has smart e-textile features like chemical, heat and cold protection, and so on are all examples of protective functioning. Protective textiles has important use cases in frie suits, chemical clothing, biological suits, and ballistic vests. In most cases we can find it in bullet proof vests as well as space suits.<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong> 9. SportTech (Sports Textiles)</strong><br/> Sports textiles, also known as Sporttex, are primarily utilised in the production of sportswear, such as sports shoes and other sports equipment. The growing popularity of active sports and outdoor leisure activities such as flying, sailing, climbing, and cycling has resulted in a massive increase in the use of textile materials in the production of sporting and related items and equipment. In the production of athletic textiles, synthetic fibres and coatings have essentially supplanted conventional cotton fabrics and other natural fibres.<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong> 10. Clothtech (Clothing Textiles)</strong> <br/>Clothtech is a technical textile subset that includes all textile materials used in garments, footwear, laces, interlinings, zip fasteners, elastic narrow fabrics (tapes), Velcro, labels, umbrella cloth, and sewing threads. Technical textiles for clothing, particularly in the finishing process, where the fabric is handled under high pressure and high temperatures, support the fabric and allow for the procedure to be carried out progressively. Typically, this is a polyester blend.<br/><br/><strong> Conclusion</strong><br/> Finally, we examined one of the most significant inventions of the recent decade: technical textiles. At first glance, it may appear to be just another material, but upon closer inspection, you&#39;ll notice that it has transformed many facets of our lives, from medicine hygiene goods to sporting apparel. <br/><br/><strong>About Sanathan Textiles </strong><br/>Sanathan Textiles is a polyester manufacturer and a global supplier of Cotton Yarns, Polyester Yarns and Yarns for Technical Textiles. With 3 yarn business verticals, we offer a wide variety of yarns that are used by various sectors and industries, across applications and end-uses. Technologically advanced and environmentally conscious manufacturing setup enables us to offer customers value-added yarns, niche yarns, functional yarns and a wide range of coloured yarns. Sanathan Textiles is committed to providing Value added Innovative Yarns for the Fabric of our Lives.",
    },
  ];

  const moreblogsArr = [
    {
      img: moreblog1,
      date: "December 9, 2019",
      category: "Lorem Ipsum",
      title:
        "Deciding on a colour scheme for your kitchen is as much about the size and shape of",
      desc: "Morbi volutpat nisi a ligula vestibulum placerat. Suspendisse venenatis pulvinar nibh sed convallis. Cras elementum nunc a purus sodales tincidunt. Duis fringilla quam at tellus consectetur, id placerat metus tincidunt. In tellus mauris, pellentesque ac est sed, vestibulum hendrerit felis. Pellentesque molestie lorem id placerat condimentum. Integer fermentum arcu at massa vestibulum placerat. Donec placerat suscipit sollicitudin. Nam pretium est sit amet urna semper ullamcorper. Nulla facilisi. Sed pellentesque tempor tempor. Vestibulum tristique pellentesque feugiat. Vivamus in nisl nec quam maximus venenatis. Sed euismod eros bibendum, dignissim erat sed, blandit tellus.",
    },
    {
      img: moreblog2,
      date: "December 9, 2019",
      category: "Lorem Ipsum",
      title:
        "Deciding on a colour scheme for your kitchen is as much about the size and shape of",
      desc: "Morbi volutpat nisi a ligula vestibulum placerat. Suspendisse venenatis pulvinar nibh sed convallis. Cras elementum nunc a purus sodales tincidunt. Duis fringilla quam at tellus consectetur, id placerat metus tincidunt. In tellus mauris, pellentesque ac est sed, vestibulum hendrerit felis. Pellentesque molestie lorem id placerat condimentum. Integer fermentum arcu at massa vestibulum placerat. Donec placerat suscipit sollicitudin. Nam pretium est sit amet urna semper ullamcorper. Nulla facilisi. Sed pellentesque tempor tempor. Vestibulum tristique pellentesque feugiat. Vivamus in nisl nec quam maximus venenatis. Sed euismod eros bibendum, dignissim erat sed, blandit tellus.",
    },
    {
      img: moreblog3,
      date: "December 9, 2019",
      category: "Lorem Ipsum",
      title:
        "Deciding on a colour scheme for your kitchen is as much about the size and shape of",
      desc: "Morbi volutpat nisi a ligula vestibulum placerat. Suspendisse venenatis pulvinar nibh sed convallis. Cras elementum nunc a purus sodales tincidunt. Duis fringilla quam at tellus consectetur, id placerat metus tincidunt. In tellus mauris, pellentesque ac est sed, vestibulum hendrerit felis. Pellentesque molestie lorem id placerat condimentum. Integer fermentum arcu at massa vestibulum placerat. Donec placerat suscipit sollicitudin. Nam pretium est sit amet urna semper ullamcorper. Nulla facilisi. Sed pellentesque tempor tempor. Vestibulum tristique pellentesque feugiat. Vivamus in nisl nec quam maximus venenatis. Sed euismod eros bibendum, dignissim erat sed, blandit tellus.",
    },
    {
      img: moreblog2,
      date: "December 9, 2019",
      category: "Lorem Ipsum",
      title:
        "Deciding on a colour scheme for your kitchen is as much about the size and shape of",
      desc: "Morbi volutpat nisi a ligula vestibulum placerat. Suspendisse venenatis pulvinar nibh sed convallis. Cras elementum nunc a purus sodales tincidunt. Duis fringilla quam at tellus consectetur, id placerat metus tincidunt. In tellus mauris, pellentesque ac est sed, vestibulum hendrerit felis. Pellentesque molestie lorem id placerat condimentum. Integer fermentum arcu at massa vestibulum placerat. Donec placerat suscipit sollicitudin. Nam pretium est sit amet urna semper ullamcorper. Nulla facilisi. Sed pellentesque tempor tempor. Vestibulum tristique pellentesque feugiat. Vivamus in nisl nec quam maximus venenatis. Sed euismod eros bibendum, dignissim erat sed, blandit tellus.",
    },
  ];

  const galleryArr = [
    {
      id: 1,
      type: "video",
      image: gallery1,
      title: "Image Name",
      ytLink: "https://www.youtube.com/embed/HHjSdy9l7Kc",
    },
    {
      id: 2,
      type: "image",
      image: gallery1,
      title: "Image Name",
      ytLink: "https://www.youtube.com/embed/HHjSdy9l7Kc",
    },
    {
      id: 3,
      type: "video",
      image: gallery1,
      title: "Image Name",
      ytLink: "https://www.youtube.com/embed/HHjSdy9l7Kc",
    },
    {
      id: 4,
      type: "image",
      image: gallery1,
      title: "Image Name",
      ytLink: "https://www.youtube.com/embed/HHjSdy9l7Kc",
    },
  ];

  useEffect(() => {
    var gallery_swiper_container = new Swiper(
      ".swiper-container.gallery_swiper_container",
      {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
          prevEl: ".bloginner_sec2 .left_arrow",
          nextEl: ".bloginner_sec2 .right_arrow",
        },
        breakpoints: {
          767: {
            slidesPerView: 1.6,
            spaceBetween: 10,
          },
          992: {
            slidesPerView: 2.7,
            spaceBetween: 10,
          },
        },
        // loop: true,
        // centeredSlides: true,
        // loopedSlides: thumbArr.length, //how many slides it should duplicate
      }
    );
    var moreblogs_swiper_container = new Swiper(
      ".swiper-container.moreblogs_swiper_container",
      {
        slidesPerView: 3,
        spaceBetween: 40,
        loop: false,
        navigation: {
          prevEl: ".bloginner_sec3 .left_arrow",
          nextEl: ".bloginner_sec3 .right_arrow",
        },
        breakpoints: {
          300: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          767: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        },
      }
    );
  });

  useEffect(() => {
    if (copied) {
      let copiedTimeout = setTimeout(() => {
        setCopied(false);
      }, 3000);
      return () => {
        clearTimeout(copiedTimeout);
      };
    }
  }, [copied]);

  const dateList = blogDateArr.map((item) => (
    <>
      <p className="blog_date">{item.date} | </p>
      <p className="blog_category"> {item.category} </p>
      <p className="blog_company">| {item.company}</p>
    </>
  ));

  const descList = blogDescArr.map((item) => (
    <>
      <p
        className="blog_desc"
        dangerouslySetInnerHTML={{ __html: item.desc1 }}
      />
    </>
  ));

  const galleryVideoImageList = galleryArr.length
    ? galleryArr.map((item, i) => (
        <div className="swiper-slide" key={i}>
          {item.type == "video" ? (
            <>
              <div
                className="video_wrapper_div"
                onClick={() => handleImageWrapperClick(item.ytLink)}
              >
                <div className="content">
                  <img
                    src={item.image}
                    alt="Sanathan video gallery img"
                    loading="lazy"
                    className="gallery_img"
                  />
                  <div className="content-overlay"></div>
                  <img
                    src={playicon}
                    alt="Sanathan coloredArrow img"
                    loading="lazy"
                    className="playicon"
                    onClick={() => handleImageWrapperClick(item.ytLink)}
                  />
                  {/* <h2 className="galleryImageName">{item.title}</h2> */}
                </div>

                {/* <h2 className="galleryImageName">{item.title}</h2> */}
              </div>
            </>
          ) : (
            <>
              <div className="content">
                <img
                  src={item.image}
                  alt="Sanathan blog gallery img"
                  loading="lazy"
                  className="gallery_img"
                />
                <div className="content-overlay"></div>
                {/* <h2 className="galleryImageName">{item.title}</h2> */}
              </div>
            </>
          )}
        </div>
      ))
    : null;

  const moreblogsList = moreblogsArr.map((item, i) => (
    <>
      <li className="swiper-slide moreblog_detail_wrapper">
        <Link to="/blog-inner" key={i}>
          <div className="imageanimate zoom-out">
            <img
              src={item.img}
              alt="Sanathan our blog img"
              loading="lazy"
              className="moreblog_img"
            />
            {/* <div className="content-overlay"></div> */}
          </div>
          <div className="text_container">
            <h1 className="moreblog_date">{item.date}</h1>
            <div className="verticle_line"> | </div>
            <h1 className="moreblog_category"> {item.category}</h1>
            <h1 className="moreblog_name">{item.title}</h1>
            <p className="moreblog_synopsis">
              {reduceDescSize(item.desc, 100)}
            </p>
            <div className="moreblog_cta_wrapper"></div>
          </div>
        </Link>
      </li>
    </>
  ));

  const handleImageWrapperClick = (videoLink) => {
    setToggler(!toggler);
    setVidLink(videoLink);
  };

  const copyUrl = () => {
    const el = document.createElement("input");
    el.value = window.location.href;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    setCopied(true);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <MetaDecorator
        canonicalLink={window.location.href}
        metaTitle="Sanathan Textiles - Re-Weaving India's Success Story"
        metaDesc="The global image of the textile industry is a bit different compared to India in the last 6 months."
      />
      {/* <Banner
        imgSrc="https://via.placeholder.com/1920x300"
        breadcrumbWord1="Home"
        breadcrumbWord3="Blogs"
        breadcrumbWord4={blogDescArr[0].heading}
        link3="blogs"
        disabled
      /> */}
      <section className="bloginner_sec1" data-aos="fade-in">
        <div className="wrapper">
          {/* <div className="breadcrumb_styles">Home {">"} Blog Inner</div> */}
          {/* <div className="blog_heading">
            Blog Heading will come here lorem ipsum lorem ipsum example text
            here
          </div> */}
          <img
            className="mainimg"
            src={blog4Banner}
            alt="re-weaving-indias-success-story"
          />
          <div className="row social_icon_date">
            <div className="col-md-6 col-lg-4 datecat_list">
              {/* {dateList} */}
            </div>
            <div className="col-md-1 col-lg-4"></div>
            <div className="col-md-5 col-lg-4">
              {width < 767 ? <h2 className="share_title">Share</h2> : null}
              <div className="social_main_wrapper">
                <ul className="social_icons">
                  {width > 767 ? (
                    <li className="social_icon_li">
                      <h2 className="share_title">Share</h2>
                    </li>
                  ) : null}
                  <li className="social_icon_li">
                    <FacebookShareButton
                      url={`${
                        window.location.href ? window.location.href : null
                      }`}
                    >
                      <span className="social_icon">
                        <img
                          src={facebook}
                          alt="Sanathan facebook logo"
                          loading="lazy"
                        />
                      </span>
                    </FacebookShareButton>
                  </li>
                  <li className="social_icon_li">
                    <WhatsappShareButton
                      url={`${
                        window.location.href ? window.location.href : null
                      }`}
                    >
                      <span className="social_icon">
                        <img
                          src={whatsapp}
                          alt="Sanathan facebook logo"
                          loading="lazy"
                        />
                      </span>
                    </WhatsappShareButton>
                  </li>
                  <li className="social_icon_li">
                    <TwitterShareButton
                      url={`${
                        window.location.href ? window.location.href : null
                      }`}
                    >
                      <span className="social_icon">
                        <img
                          src={twitterblog}
                          alt="Sanathan facebook logo"
                          loading="lazy"
                        />
                      </span>
                    </TwitterShareButton>
                  </li>
                  <li
                    className="social_icon_li social_icon_li_copy"
                    onClick={copyUrl}
                  >
                    <span className="social_icon">
                      <img
                        src={copy}
                        alt="Sanathan copy url logo"
                        loading="lazy"
                      />
                    </span>
                    <span className="social_name">
                      {!copied ? "" : "Copied!"}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="horizontal_line"></div>
          <h1 className="blog_inner_name">
            Re-Weaving India’s Success Story
          </h1>
          <div className="blog_desc">
            <p>
              India is globally known to set examples and break benchmarks as we
              proceed and lead from the front. This year India has celebrated 75
              years of sheer growth in Industrial and Capital progress as we
              have memorised our 75 years of independence by weaving fibre into
              fashion.
            </p>
            <p>&nbsp;</p>
            <p>
              India has a long way ahead with leaders leading and industries
              creating opportunities for growth and change to be impacted.
              India&rsquo;s textile sector is one of the oldest industries in
              the Indian economy, dating back several centuries and with a young
              growing population, international brands are setting up hubs in
              India to source locally so India can increase its potential by
              expanding its ecosystem.
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>The Impact Of The Global Textile Market On India </strong>
            </p>
            <p>
              The global image of the textile industry is a bit different
              compared to India in the last 6 months because of the Russia and
              Ukraine conflict. The war has created trade barriers for the world
              at large with an increase in raw material and energy prices that
              have impacted overall global consumption. The buying pattern has
              also come down but the opportunities that favour Indian players in
              the textile industry, have created support for the positive boost
              in India. A growing domestic market and China plus one model is
              giving India new opportunities every day at a global level.
            </p>
            <p>&nbsp;</p>
            <p>
              The global textile market size is valued at USD 993. 6 billion in
              2021 and is anticipated to grow at a compound annual growth rate
              (CAGR) of 4.0% from 2022 to 2030. The increasing market size and
              its valuation signify the scope of growth that India can tap into.
              India is a country with the majority of the population being young
              and employed which makes it have enough buyers internally. Further
              considering the increase in demand for fabric and textiles and the
              increase in per capita income, the spending limits of the
              population to has increased. Such spending limits have not only
              increased the demand for textiles internally but also the youths
              believe that textile has to be made from sustainable practices.
            </p>
            <p>&nbsp;</p>
            <p>
              The Global industry has understood that too much supply from one
              country can impact the economy if there is no other sourcing
              country and hence China Plus one model has helped India scale its
              production. This fruit from the model plant is been seen and
              it&rsquo;s a long-term influence, which shall have a larger impact
              as we progress further. The demand for the Indian textile industry
              will continue to increase by 10-12% CAGR.
            </p>
            <p>&nbsp;</p>
            <p>
              The global synthetic fibre market was estimated at USD 62.93
              billion in 2021 and is expected to reach USD 98.21 billion growing
              at a CAGR of 5.1% over the forecast period. Increasing consumer
              demand for cost-effective, durable, and easy-to-wash &amp;
              maintainable fabrics is expected to drive the market growth over
              the forecast period.
            </p>
            <p>&nbsp;</p>
            <p>
              These fibres are preferred in various application industries such
              as clothing, home furnishing, filtration, and automotive, on
              account of their unique properties including excellent chemical,
              mechanical, and physical properties such as strength, softness,
              elasticity, crease recovery, and high lustre. At Sanathan
              Textiles, we have introduced performance yarn products like
              Sanathan Drycool which are used for athleisure and Sanathan
              Stretch to cater to the requirement of Young India.&nbsp;
            </p>
            <p>&nbsp;</p>
            <p>
              The Asia Pacific dominated the market in 2021 and is expected to
              witness the fastest growth over the forecast period due to factors
              such as increasing urban population, rising awareness regarding
              fitness awareness, growing demand for clothing, and escalating
              increasing disposable incomes are expected to drive the growth of
              the apparel &amp; textile industry in the region. In addition,
              shifting fashion trends coupled with the rising urban population
              with modern living standards are expected to provide
              opportunities.
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>
                Technological Adaptation- A Boon To The Indian Textile Industry{" "}
              </strong>
            </p>
            <p>
              The market has been witnessing an increasing adoption of advanced
              technology and methods. The market players are trying to increase
              their sales through investment, partnerships, and agreements with
              brand owners, e-commerce facilitators, and retailers to facilitate
              overall market growth. Industry players focus on technological
              advancements in the manufacturing process, to minimize the
              environmental impact. In addition, the players are investing
              heavily in R&amp;D to overcome environmental concerns.
            </p>
            <p>&nbsp;</p>
            <p>
              The game does not belong to the survivor, but to the winner who
              innovates and uses technology to expand. Hence, the Indian textile
              industry needs to invest heavily in technology and innovation and
              that will create an impact. The increase in technology and
              innovation will increase production capacity and reduce cost,
              which will support the future of the textile industry.
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>Government Policies Support</strong>
            </p>
            <p>
              The Government of India is writing policies that will create a
              future impact by investing in the right drivers. The Government of
              India has earmarked a corpus of Rs. 1,000 crores (US$ 127.72
              million) dedicated to research and development of the{" "}
              <a href="/products/yarn-for-technical-textile" target="_blank">
                technical textiles
              </a>{" "}
              sector. Under the Union Budget 2022-23, the total allocation for
              the textile sector was Rs. 12,382 crores (US$ 1.62 billion). Out
              of this, Rs.133.83 crore (US$ 17.5 million) is for the Textile
              Cluster Development Scheme, Rs. 100 crores (US$ 13.07 million) for
              the National{" "}
              <a href="/products/yarn-for-technical-textile" target="_blank">
                Technical Textiles
              </a>{" "}
              Mission, and Rs. 15 crores (US$ 1.96 million) each for PM Mega
              Integrated Textile Region and Apparel parks scheme and the PLI
              Scheme. The government allocated funds worth Rs. 17,822 crores
              (US$ 2.38 billion) between FY16-22 for the &lsquo;Amended
              Technology Up-gradation Fund Scheme&rsquo; (A-TUFS), to boost the
              Indian textile industry and enable ease of doing business. The
              policies and initiatives taken by the Government of India depict
              the faith it is investing in the industry to explore and expand.
              India has the potential to increase its capacity and the growth is
              visible, it&rsquo;s time for the manufacturing of quality yarns
              for garments for India and the world.
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>Textile Industry Featuring Sanathan Textiles</strong>
            </p>
            <p>
              At Sanathan Textiles, we believe that India and its textile
              players in the industry have a huge scope for expansion and the
              production capacity will increase when innovation is bonded with
              technology, to optimise, the economies of scale. We manufacture
              yarns in{" "}
              <a href="/products/polyester-yarn" target="_blank">
                polyester
              </a>
              ,{" "}
              <a href="/products/cotton-yarn" target="_blank">
                cotton,
              </a>{" "}
              and yarns for technical textiles. We believe the right investment
              in the proper technology is the key to growth. Sanathan Textiles
              caters to more than 1000+ customers locally and globally and
              manufactures SKUs to cater to customer demands.
            </p>
            <p>&nbsp;</p>
            <p>
              As India completed 75 years, Sanathan Textiles have completed more
              than 15 years in the manufacturing of world-class quality yarns,
              but the promoter family has more than 5 decades of experience in
              the yarn and textile industry, which helps the Company learn from
              the past and drive the path for its future growth. The increase in
              production creates employment opportunities, which further
              increases the capacity of the population to spend. A lot of
              international brands are coming to India and Indian local
              manufacturers working with International brands create a huge
              impact on the economy. At Sanathan Textiles, the Leadership team
              is of the firm opinion that sustainable investment is necessary,
              because production should increase but not at the cost of
              destroying our planet, and hence, we have also invested in
              renewable energy, thereby reducing the carbon footprint on the
              planet.
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>
                Many Innovative Products We Believe Will Help Sanathan Textiles
                Explore And Expand Such As:{" "}
              </strong>
            </p>
            <p>
              Sanathan Borndyed is our coloured yarn, which uses dope-dyed
              technology to produce colour{" "}
              <a href="/products/polyester-yarn" target="_blank">
                polyester
              </a>{" "}
              yarn. We reduce water consumption by 83%, chemicals by 63%, and
              lower production costs. Shortening the supply chain helps in
              reduced production costs and ensures a reduction in the ecological
              footprint of the final products.
            </p>
            <p>&nbsp;</p>
            <p>
              Sanathan Reviro is yarn manufactured from PET chips which are made
              from waste recycled bottles. With Sanathan Reviro, we endeavour to
              contribute to the new world&rsquo;s efforts toward Reducing,
              Reusing, and Recycling sustainable fabrics. Sanathan Puro is yarn
              made for apparel, suiting, shirting, bedsheets, home textiles, and
              other uses.
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>Scenario Of The Indian Textile Industry </strong>
            </p>
            <p>
              The domestic apparel &amp; textile industry in India contributes
              2% to the country&rsquo;s GDP, 7% of industry output in value
              terms, and the share of textile, apparel, and handicrafts in
              India&rsquo;s total exports was 11.4% in 2020-21. India holds a 4%
              share of the global trade in textiles and apparel. India is the
              6th largest exporter of textiles and apparel in the world. India
              is one of the largest producers of{" "}
              <a href="/products/cotton-yarn" target="_blank">cotton</a>{" "}
              and jute in the world. India is also the 2nd largest producer of
              silk in the world and 95% of the world&rsquo;s hand-woven fabric
              comes from India. The Indian technical textiles segment is
              estimated at $16 bn, approximately 6% of the global market. The
              textiles and apparel industry in India is the 2nd largest employer
              in the country providing direct employment to 45 million people
              and 100 million people in allied industries.
            </p>
            <p>&nbsp;</p>
            <p>
              The re-weaving of India&rsquo;s success story for the textile
              industry is in the hands of the future leaders when it invests
              heavily in innovation, to such an extent that zero pollution, full
              capacity, and efficiency of production are prioritized more than
              before, as that will optimise the sustainability to explore and
              expand locally and globally.
            </p>
           
           
          </div>

          {/* <div>{descList}</div> */}
        </div>
      </section>

      {/* {galleryVideoImageList && (
        <section className="bloginner_sec2" data-aos="fade-up">
          <div className="wrapper">
            <div className="heading_arrow_flex">
              <div className="gallery_heading">Gallery</div>
              {width > 767 ? (
                <div className="navigations">
                  <button className="left_arrow">Previous</button>
                  <button className="right_arrow">Next</button>
                </div>
              ) : null}
            </div>
            <div className="gallery_slider_wrapper">
              <div className="swiper-container gallery_swiper_container">
                <div className="swiper-wrapper">{galleryVideoImageList}</div>
              </div>
              {width < 767 ? (
                <div className="arrows_wrapper">
                  <div className="navigations">
                    <button className="left_arrow">Previous</button>
                    <button className="right_arrow">Next</button>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </section>
      )} */}

      {/* <section className="bloginner_sec3" data-aos="fade-up">
        <div className="horizontal_line"></div>
        <div className="wrapper">
          <div className="heading_arrow_flex2">
            <h2 className="moreblog_heading">More Blogs</h2>
            {width > 767 ? (
              <div className="navigations">
                <button className="left_arrow">Previous</button>
                <button className="right_arrow">Next</button>
              </div>
            ) : null}
          </div>

          <div className="moreblogs_wrapper">
            <div className="swiper-container moreblogs_swiper_container">
              <ul className="swiper-wrapper moreblogs_swiper_wrapper">
                {moreblogsList}
              </ul>
            </div>
            {width < 767 ? (
              <div className="arrows_wrapper">
                <div className="navigations">
                  <button className="left_arrow">Previous</button>
                  <button className="right_arrow">Next</button>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </section> */}
      {/* <FsLightbox toggler={toggler} sources={[vidLink]} /> */}
    </>
  );
};

export default BlogInner;
